import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import PrestadoresSolicitud from './PrestadoresSolicitud';
import AfiliadosSolicitud from './AfiliadosSolicitud';
import SuperAdminHub from './SuperAdminHub';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Enrutador Inteligente por Subdominios y Hash:
const Main = () => {
  const [hash, setHash] = useState(window.location.hash);
  const hostname = window.location.hostname;
  const pathname = window.location.pathname;

  console.log(`[Router] Host: ${hostname}, Path: ${pathname}, Hash: ${hash}`);

  useEffect(() => {
    const handleHashChange = () => setHash(window.location.hash);
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  // 1. Lógica de Subdominios (Prioridad Máxima)
  const isHub = hostname.toLowerCase().includes('hub.');
  const isGestion = hostname.toLowerCase().includes('gestion.') || hostname.toLowerCase().includes('core.');
  const isAltas = hostname.toLowerCase().includes('altas.');
  const isComercios = hostname.toLowerCase().includes('comercios.');

  console.log(`[Router DEBUG] Host: ${hostname}, isHub: ${isHub}, isGestion: ${isGestion}, Path: ${pathname}`);

  // HUB (Super Admin Central)
  if (isHub) return <SuperAdminHub />;

  // SOLICITUDES
  if (isAltas) return <AfiliadosSolicitud />;
  if (isComercios) return <PrestadoresSolicitud />;
  
  // GESTIÓN ADMINISTRATIVA (Admins y Operadores)
  if (isGestion) {
    if (!pathname.toLowerCase().includes('admin.html')) {
        console.log("[Router] Redirigiendo a admin.html...");
        window.location.href = '/admin.html';
        return <div style={loadingStyle}>Abriendo Panel de Gestión...</div>;
    }
    return null;
  }

  // 2. Lógica por Hash (Retrocompatibilidad)
  if (hash === '#prestadores') return <PrestadoresSolicitud />;
  if (hash === '#afiliados') return <AfiliadosSolicitud />;

  // Por defecto (app.supaso.org y beneficios.supaso.org)
  return <App />;
};

const loadingStyle = {
  background: '#0F172A',
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  fontFamily: 'Inter, sans-serif',
  fontWeight: '800',
  letterSpacing: '0.1em'
};

root.render(<Main />);
